import { DetailChip } from "@design-system/DataDisplay/DetailChip";
import { Icon } from "@design-system/Icon";
import { Button } from "@design-system/Inputs/Button";
import { FlexCol, FlexRow } from "@design-system/Layout/Flex";
import { Text } from "@design-system/Typography/Text";
import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { RESOURCE_NAME, keys } from "../../i18n";

type DittoGuidanceActiveProps = {
    onExitGuidance: () => void;
};

export const DittoGuidanceActive: FC<DittoGuidanceActiveProps> = ({
    onExitGuidance,
}) => {
    const { t } = useTranslation(RESOURCE_NAME);

    return (
        <FlexCol gap="4">
            <FlexRow
                alignItems="start"
                justifyContent="between"
                className="bg-neutral-900 text-white p-4"
            >
                <FlexRow alignItems="center" gap="2">
                    <Icon name="ecoVadis" className="h-7 w-7" />
                    <Text variant="body-lg-bold">
                        {t(keys.ditto_guidance_ecovadis_title)}
                    </Text>
                </FlexRow>
                <Button variant="outlined" size="sm" onClick={onExitGuidance}>
                    {t(keys.ditto_guidance_exit)}
                    <Button.Icon name="close" />
                </Button>
            </FlexRow>

            <FlexCol className="bg-white px-4">
                <FlexRow
                    alignItems="center"
                    justifyContent="between"
                    alignSelf="stretch"
                    pb="2"
                >
                    <FlexRow alignItems="center" gap="2" alignSelf="stretch">
                        <Text
                            variant="body-sm-bold"
                            color="primary"
                            className="uppercase"
                        >
                            {t(keys.ditto_guidance_banner_title)}
                        </Text>

                        <DetailChip>
                            <DetailChip.Icon name="logo" />
                        </DetailChip>
                    </FlexRow>
                </FlexRow>
                <Text variant="body-sm" color="secondary">
                    {t(keys.ditto_guidance_banner_description)}
                </Text>
            </FlexCol>
        </FlexCol>
    );
};
